<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/01/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/01/profile_sp.png')"
    profileAlt="01 TAKENORI TOSE"
    answer01="修士時代は理化学研究所にて、有機化学を軸に光化学や磁気化学を複合させた「超分子化学」について研究しました。具体的には、有機化学、液晶化学、高分子化学、光化学、磁気化学等の様々な分野を複合させて新規特性の発見を目指し、大面積に配向した不斉液晶から成る有機ゼオライトの開発とそのアプリケーションに関する研究を行っていました。その研究室はメンバーの３分の２がアジアやアメリカなどの外国人で、とても議論が活発。自分の意見を発信する重要性を実感しましたね。"
    answer02="就職活動中は、BtoB・BtoC問わず素材・化学メーカーを志望。決め手となったのは選考途中の座談会で、実際にクレハで働く社員の方々の生の声を聞いたことでした。新しいものを生み出すことへの熱意に感銘を受けたと同時に、アットホームで和やかな空気に「こんな環境で働きたい」と強く思いました。また、話をしてくれた社員の中には入社3-4年目の方も多くいて、若いうちから活躍できる会社だと分かったことも理由のひとつ。今は自分が社員として座談会に参加しているので、少し感慨深いです。"
    answer03="クレハが世界で初めて工業生産に成功したPGA樹脂「Kuredux®」の製造法に関して、基礎解析および反応を速める効率的な処方の開発に取り組んでいます。PGAは溶解させるのが難しく、分析手法が限られていました。そこで、専門的な分析機器を有する外部機関などと連携して新規分析手法を開発し、得られた解析結果から新規処方を検討しています。中でも、生産拠点であるアメリカに2か月間出張し、新しい製造方法の試行および新規分析手法の確立に取り組んだことは非常に印象に残っています。"
    answer04="直近の目標は、現在手掛けているPGAの新しい製造方法を軌道に乗せ、安定生産・生産増大に寄与すること。将来的に挑戦したいことは、世の中の皆様が幸せになるような「新たな価値」をつくることです。クレハが扱っている素材はまだまだ可能性に満ち溢れています。様々な用途に対応できるポテンシャルを最大限に引き出し、より良い暮らしや未来に貢献したい。そのためには、自分の得意分野を活かしながらさらに幅広い知識を身に着け、多くのことを学んでいきたいです。"
    answer05="入社1年目でも10年目でも関係なく、自由に意見を発信できる雰囲気があるところ。いわきの事業所は、部署の垣根を超えてフランクに話し合いができる風通しのいい環境。検討会や打ち合わせでの議論も活発です。また、社員同士の距離が近いため、プライベートで遊びに行く機会や飲みに行く機会が多いです。キャンプ場やサーフィン等のアクティビティも充実していて、冬はスノーボード旅行に出かけるのが毎年の楽しみです。"
    answer06="旅行が趣味なのでいろいろなところに出かけます。特に最近ハマっているのは国内の名湯をめぐる温泉旅行です。北から南までさまざまな場所の温泉に浸かって体を癒すだけでなく、綺麗な景色を眺めて心までリフレッシュできるので最高です。休日に思いっきり羽を伸ばすことで、生活にメリハリがついてより一層仕事に集中することができます。"
    :imageCut01="require('../../assets/img/lab/staff/01/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/01/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/01/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/01/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/01/schedule.svg')"
    :scheduleSp="require('../../assets/img/lab/staff/01/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
